(function () {
  'use strict';

  function euro(amountCents) {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amountCents / 100);
  }
  function normalize(s) {
    return (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }
  function qs(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  var ENVIO_EUR_CENTS = 395;
  var ENVIO_GRATIS_DESDE_CENTS = 2499;
  function shippingFor(subtotalCents) {
    return subtotalCents >= ENVIO_GRATIS_DESDE_CENTS ? 0 : ENVIO_EUR_CENTS;
  }

  /* ---------- Countdown (cosmético, 10 min, arranca en cada carga) ---------- */
  function startCountdowns() {
    var total = 600;
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    function tick() {
      total = Math.max(0, total - 1);
      var m = String(Math.floor(total / 60)).padStart(2, '0');
      var s = String(total % 60).padStart(2, '0');
      els.forEach(function (el) {
        el.textContent = (el.getAttribute('data-label') || 'Tu carrito está reservado por') + ' ' + m + ':' + s;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderDrawer(cart) {
    var empty = document.getElementById('cart-drawer-empty');
    var full = document.getElementById('cart-drawer-full');
    var countEl = document.getElementById('cart-drawer-count');
    var badge = document.getElementById('cart-count');
    if (!empty || !full) return;

    if (badge) {
      if (cart.item_count > 0) { badge.hidden = false; badge.textContent = cart.item_count; }
      else badge.hidden = true;
    }
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    if (cart.item_count === 0) {
      empty.hidden = false;
      full.hidden = true;
      return;
    }
    empty.hidden = true;
    full.hidden = false;

    var ul = document.getElementById('cart-lines');
    ul.innerHTML = cart.items.map(function (item) {
      return '' +
        '<li class="cart-line">' +
        '<a href="' + item.url + '" class="thumb"><img src="' + (item.image || '') + '&width=160" alt="" loading="lazy"></a>' +
        '<div class="body">' +
        '<a href="' + item.url + '" class="name">' + item.product_title + '</a>' +
        '<div class="row">' +
        '<div class="qty-stepper" data-line-key="' + item.key + '">' +
        '<button type="button" data-qty="-1" aria-label="Una menos"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="14" height="14"><path d="M5 12h14"/></svg></button>' +
        '<span class="cifra">' + item.quantity + '</span>' +
        '<button type="button" data-qty="1" aria-label="Una más"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="14" height="14"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div>' +
        '<div>' +
        '<p class="price cifra">' + euro(item.line_price) + '</p>' +
        '<button type="button" class="remove" data-line-remove="' + item.key + '">Quitar</button>' +
        '</div>' +
        '</div></div></li>';
    }).join('');

    var shipping = shippingFor(cart.items_subtotal_price);
    document.getElementById('cart-subtotal').textContent = euro(cart.items_subtotal_price);
    document.getElementById('cart-shipping').textContent = shipping === 0 ? 'Gratis' : euro(shipping);
    document.getElementById('cart-total').textContent = euro(cart.items_subtotal_price + shipping);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }
  function refreshCart() {
    return fetchCart().then(function (cart) {
      renderDrawer(cart);
      renderCartPage(cart);
      return cart;
    });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(); });
  }
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart], #pdp-add-cart');
    if (addBtn) {
      var vid = addBtn.getAttribute('data-variant-id');
      if (!vid) return;
      var original = addBtn.textContent;
      addToCart(vid, 1).then(function () {
        addBtn.textContent = 'Añadido';
        openDrawer();
        setTimeout(function () { addBtn.textContent = original; }, 1600);
      });
      return;
    }

    var buyNow = e.target.closest('#pdp-buy-now');
    if (buyNow) {
      var vid2 = buyNow.getAttribute('data-variant-id');
      addToCart(vid2, 1).then(function () { window.location.href = '/checkout'; });
      return;
    }

    if (e.target.closest('#cart-open-btn')) { openDrawer(); return; }
    if (e.target.closest('#cart-close-btn') || e.target.closest('#cart-overlay') || e.target.closest('#cart-continue-btn')) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      var stepper = qtyBtn.closest('[data-line-key]');
      var key = stepper.getAttribute('data-line-key');
      var delta = parseInt(qtyBtn.getAttribute('data-qty'), 10);
      var current = parseInt(stepper.querySelector('span').textContent, 10);
      changeLine(key, Math.max(0, current + delta));
      return;
    }
    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) { changeLine(removeBtn.getAttribute('data-line-remove'), 0); return; }

    if (e.target.closest('#cart-page-clear')) {
      fetch('/cart/clear.js', { method: 'POST' }).then(refreshCart);
      return;
    }
    if (e.target.closest('#cart-page-checkout')) { window.location.href = '/checkout'; return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Cart page (JS-rendered desde /cart.js) ---------- */
  function renderCartPage(cart) {
    var root = document.getElementById('cart-page-root');
    if (!root) return;
    var empty = document.getElementById('cart-page-empty');
    var full = document.getElementById('cart-page-full');

    if (cart.item_count === 0) { empty.hidden = false; full.hidden = true; return; }
    empty.hidden = true; full.hidden = false;

    var PEDIDO_MINIMO_CENTS = 499;
    var ul = document.getElementById('cart-page-lines');
    ul.innerHTML = cart.items.map(function (item) {
      return '' +
        '<li class="cart-page-line">' +
        '<a href="' + item.url + '" class="thumb"><img src="' + (item.image || '') + '&width=200" alt="" loading="lazy"></a>' +
        '<div class="body">' +
        '<a href="' + item.url + '" class="name">' + item.product_title + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="model">' + item.variant_title + '</p>' : '') +
        '<p class="unit cifra">' + euro(item.price) + ' / ud</p>' +
        '<div class="row">' +
        '<div class="qty-stepper" data-line-key="' + item.key + '">' +
        '<button type="button" data-qty="-1" aria-label="Una menos">−</button>' +
        '<span class="cifra">' + item.quantity + '</span>' +
        '<button type="button" data-qty="1" aria-label="Una más">+</button>' +
        '</div>' +
        '<button type="button" class="remove" data-line-remove="' + item.key + '" style="background:none;border:0;color:var(--tinta-suave);text-decoration:underline;font-size:12px">Quitar</button>' +
        '</div></div>' +
        '<p class="line-total cifra">' + euro(item.line_price) + '</p>' +
        '</li>';
    }).join('');

    var subtotal = cart.items_subtotal_price;
    var shipping = shippingFor(subtotal);
    var bajoMinimo = subtotal > 0 && subtotal < PEDIDO_MINIMO_CENTS;

    document.getElementById('cart-page-subtotal').textContent = euro(subtotal);
    document.getElementById('cart-page-shipping').textContent = shipping === 0 ? 'Gratis' : euro(shipping);
    document.getElementById('cart-page-total').textContent = euro(subtotal + shipping);

    var note = document.getElementById('cart-page-shipping-note');
    var checkoutBtn = document.getElementById('cart-page-checkout');
    if (bajoMinimo) {
      note.textContent = 'Pedido mínimo ' + euro(PEDIDO_MINIMO_CENTS) + '. Añade ' + euro(PEDIDO_MINIMO_CENTS - subtotal) + ' más.';
      note.classList.add('warn');
      checkoutBtn.textContent = 'Mínimo ' + euro(PEDIDO_MINIMO_CENTS);
      checkoutBtn.disabled = true;
    } else {
      note.classList.remove('warn');
      note.textContent = shipping > 0 ? ('Te faltan ' + euro(ENVIO_GRATIS_DESDE_CENTS - subtotal) + ' para el envío gratis.') : '';
      checkoutBtn.textContent = 'Pagar con tarjeta';
      checkoutBtn.disabled = false;
    }
  }

  /* ---------- Discount popup ---------- */
  function initPopup() {
    var overlayEl = document.getElementById('discount-popup-overlay');
    if (!overlayEl) return;
    var closeBtn = document.getElementById('discount-popup-close');
    var KEY = 'cartuchoya_popup_boletin';
    var WEEK = 7 * 24 * 60 * 60 * 1000;

    function show() { overlayEl.classList.add('open'); }
    function hide() {
      overlayEl.classList.remove('open');
      try { window.localStorage.setItem(KEY, new Date().toISOString()); } catch (e) {}
    }
    if (closeBtn) closeBtn.addEventListener('click', hide);
    overlayEl.addEventListener('click', function (e) { if (e.target === overlayEl) hide(); });

    if (qs('descuento') === '1') { show(); return; }

    var last = null;
    try { last = window.localStorage.getItem(KEY); } catch (e) {}
    if (last) {
      var since = Date.now() - new Date(last).getTime();
      if (!isNaN(since) && since < WEEK) return;
    }
    setTimeout(function () {
      show();
      try { window.localStorage.setItem(KEY, new Date().toISOString()); } catch (e) {}
    }, 9000);
  }

  /* ---------- Social proof (PDP) ---------- */
  function initSocialProof() {
    var el = document.getElementById('social-proof');
    if (!el) return;
    var GRUPOS = [
      { a: 'Andrea', b: 'Lucía', mas: 16 },
      { a: 'María', b: 'Pablo', mas: 12 },
      { a: 'Sofía', b: 'Carlos', mas: 9 },
      { a: 'Laura', b: 'Javier', mas: 14 },
    ];
    function iniciales(n) { return n.slice(0, 1).toUpperCase(); }
    function render(i) {
      var g = GRUPOS[i];
      el.innerHTML =
        '<span class="avatars">' +
        '<span>' + iniciales(g.a) + '</span><span>' + iniciales(g.b) + '</span>' +
        '<span class="more">+' + g.mas + '</span></span>' +
        '<span><strong>' + g.a + '</strong> y <strong>' + g.b + '</strong> y ' + g.mas + ' más compraron esta semana</span>';
    }
    var dias = Math.floor(Date.now() / 86400000);
    var idx = dias % GRUPOS.length;
    render(idx);
    setInterval(function () { idx = (idx + 1) % GRUPOS.length; render(idx); }, 5000);
  }

  /* ---------- PDP gallery thumbs ---------- */
  function initGallery() {
    var thumbs = document.querySelectorAll('[data-thumb]');
    var main = document.getElementById('pdp-main-img');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        main.src = t.getAttribute('data-full');
      });
    });
  }

  /* ---------- PDP variant picker (color) ---------- */
  function initVariantPicker() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;
    var variants;
    try { variants = JSON.parse(picker.getAttribute('data-product-json')); } catch (e) { return; }

    var buyBtn = document.getElementById('pdp-buy-now');
    var addBtn = document.getElementById('pdp-add-cart');

    function applySelection() {
      var groups = picker.querySelectorAll('[data-option-index]');
      var selected = [];
      picker.querySelectorAll('.plp-chip.active').forEach(function (btn) {
        selected[parseInt(btn.getAttribute('data-option-index'), 10)] = btn.getAttribute('data-value');
      });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === undefined || opt === selected[i]; });
      });
      if (!match) return;
      if (buyBtn) buyBtn.setAttribute('data-variant-id', match.id);
      if (addBtn) addBtn.setAttribute('data-variant-id', match.id);
      var priceEl = document.querySelector('.pdp-price');
      if (priceEl && match.price) priceEl.textContent = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(match.price / 100);
    }

    picker.querySelectorAll('.plp-chip').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        picker.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (sib) { sib.classList.remove('active'); });
        btn.classList.add('active');
        applySelection();
      });
    });
  }

  /* ---------- Productos: buscador/filtro/orden (client-side, como Next.js) ---------- */
  function initProductList() {
    var dataEl = document.getElementById('plp-data');
    if (!dataEl) return;
    var all = JSON.parse(dataEl.textContent);
    var grid = document.getElementById('plp-grid');
    var titleEl = document.getElementById('plp-title');
    var countEl = document.getElementById('plp-count');
    var emptyEl = document.getElementById('plp-empty');
    var emptyText = document.getElementById('plp-empty-text');
    var searchInput = document.getElementById('plp-search');
    var filtersWrap = document.getElementById('plp-filters');
    var hayToggle = document.getElementById('plp-hay-toggle');

    var state = {
      q: qs('q') || '',
      cat: qs('cat') || '',
      orden: qs('orden') || 'precio-asc',
      hay: qs('hay') === '1',
    };
    searchInput.value = state.q;

    function syncUrl() {
      var p = new URLSearchParams();
      if (state.q) p.set('q', state.q);
      if (state.cat) p.set('cat', state.cat);
      if (state.orden !== 'precio-asc') p.set('orden', state.orden);
      if (state.hay) p.set('hay', '1');
      var s = p.toString();
      history.replaceState(null, '', s ? '/pages/productos?' + s : '/pages/productos');
    }

    function cardHtml(p) {
      var soldBadge = !p.available ? '<span class="badge-sold">Agotado</span>' : '';
      var priceHtml = p.price > 0
        ? '<p class="price cifra">' + new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(p.price / 100) + '</p>'
        : '<p class="price cifra"><span style="font-size:13px;font-weight:400;color:var(--tinta-suave)">Precio a consultar</span></p>';
      var action = !p.available
        ? '<span class="btn btn-full btn-disabled">Agotado</span>'
        : p.price <= 0
          ? '<span class="btn btn-full btn-disabled">Consultar precio</span>'
          : '<button type="button" class="btn btn-full btn-dark" data-add-to-cart data-variant-id="' + p.variantId + '">Añadir a la cesta</button>';
      return '' +
        '<li class="product-card">' +
        '<a href="' + p.url + '" class="thumb">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + soldBadge + '</a>' +
        '<div class="info"><a href="' + p.url + '"><h3>' + p.title + '</h3><p class="model">' + (p.type || '') + '</p></a>' +
        priceHtml +
        '<div class="actions">' + action + '</div></div></li>';
    }

    function render() {
      var needle = normalize(state.q);
      var items = all.filter(function (p) {
        if (state.cat && p.type !== state.cat) return false;
        if (state.hay && !p.available) return false;
        if (!state.q) return true;
        return normalize(p.title + ' ' + (p.type || '')).indexOf(needle) !== -1;
      });
      items.sort(function (a, b) {
        if (state.orden === 'nombre') return a.title.localeCompare(b.title, 'es');
        if (state.orden === 'precio-desc') return b.price - a.price;
        return a.price - b.price;
      });

      titleEl.textContent = state.cat || 'Todos los productos';
      countEl.textContent = items.length + (items.length === 1 ? ' artículo' : ' artículos');

      filtersWrap.querySelectorAll('[data-cat]').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-cat') === state.cat);
      });
      filtersWrap.querySelectorAll('[data-orden]').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-orden') === state.orden);
      });
      hayToggle.classList.toggle('active', state.hay);
      hayToggle.classList.toggle('avail', state.hay);

      if (items.length === 0) {
        emptyEl.hidden = false;
        grid.hidden = true;
        emptyText.textContent = 'No hay nada' + (state.q ? ' para "' + state.q + '"' : '') + (state.cat ? ' en ' + state.cat : '') + '.';
      } else {
        emptyEl.hidden = true;
        grid.hidden = false;
        grid.innerHTML = items.map(cardHtml).join('');
      }
      syncUrl();
    }

    var t;
    searchInput.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.q = searchInput.value.trim(); render(); }, 150);
    });
    filtersWrap.addEventListener('click', function (e) {
      var catBtn = e.target.closest('[data-cat]');
      if (catBtn) { state.cat = catBtn.getAttribute('data-cat'); render(); return; }
      var ordBtn = e.target.closest('[data-orden]');
      if (ordBtn) { state.orden = ordBtn.getAttribute('data-orden'); render(); return; }
      if (e.target.closest('#plp-hay-toggle')) { state.hay = !state.hay; render(); return; }
    });

    render();
  }

  function initHeroVideo() {
    var v = document.querySelector('.hero-video');
    if (v && window.matchMedia('(prefers-reduced-motion: reduce)').matches) v.pause();
  }

  document.addEventListener('DOMContentLoaded', function () {
    startCountdowns();
    initPopup();
    initSocialProof();
    initGallery();
    initVariantPicker();
    initProductList();
    initHeroVideo();
    refreshCart();
  });
})();
